@import 'styles/mixins';
@import 'styles/variables';

// The double class is to allow overriding button styles by using higher specificity
.root.iconButton {
  padding: 6px;
  flex-shrink: 0;

  &.sm {
    min-width: 28px;
    min-height: 28px;
  }

  &.md {
    min-width: 32px;
    min-height: 32px;
  }

  &.lg {
    min-width: 36px;
    min-height: 36px;
  }

  &.xl {
    padding: 10px;
    min-width: 44px;
    min-height: 44px;
  }
}
